module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('document-container', {
    attrs: {
      "body": _vm.template.body(),
      "footer": _vm.template.footer(),
      "header": _vm.template.header(),
      "logo": _vm.logo,
      "tables": _vm.tables,
      "documentType": "onepager"
    }
  }, [_vm._l((_vm.template.body()), function(block) {
    return _c('div', {
      class: block.type !== 'Pagebreak' ? 'page-block' : '',
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [(block.type !== 'ProductTable') ? _c(block.type, {
      tag: "component",
      attrs: {
        "data": block
      }
    }) : _vm._e(), _vm._v(" "), (block.type === 'ProductTable') ? _c('product-table', {
      attrs: {
        "id": "product-table",
        "table": _vm.tables.findTable('product-table')
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.template.config.longDisclaimer && _vm.template.config.longDisclaimer.body.length > 0) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('textblock', {
    attrs: {
      "data": _vm.template.config.longDisclaimer
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d3c692"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/onepager/Onepager.vue
// module id = 699
// module chunks = 0